@if (message.status === 'rejected') {
  <div
    class="text-content t-7@r font-style-italic color-ash border border-radius-pill"
    [class.cursor-pointer]="message.is_me"
    (click)="message.is_me && onPhotoDisapprovedClick()"
  >
    <sb-icon class="color-cloud" [name]="'alert-circle'" [size]="'10'" />
    Photo disapproved
  </div>
} @else if (message.status === 'reported') {
  <div class="text-content t-7@r font-style-italic color-ash border border-radius-pill">
    <sb-icon class="color-cloud" [name]="'ban'" [size]="'10'" />
    Photo reported
  </div>
} @else if (message.status === 'viewed') {
  <div class="text-content t-7@r font-style-italic color-ash border border-radius-pill">
    <sb-icon class="color-cloud" [name]="'picture'" [size]="'10'" />
    Photo viewed
  </div>
} @else if (message.status === 'expired') {
  <div class="text-content t-7@r font-style-italic color-ash border border-radius-pill">
    <sb-icon class="color-cloud" [name]="'clock'" [size]="'10'" />
    Photo expired
  </div>
} @else {
  <div class="photo-wrapper position-relative bg-jet border-radius-16 overflow-hidden">
    @if ((message.status === 'viewable' && message.is_me) || message.status === 'pending') {
      <div
        class="photo fill-parent-with-radius img fs-exclude"
        [style.--photo-bg]="(message.photo | urlBlobCache) ?? message.photo.thumb_url | bg"
      ></div>
    } @else {
      <sb-icon class="color-ash mf-4 position-absolute left-0 top-0" [name]="'picture'" [size]="'5'" />
    }

    @switch (message.status) {
      @case ('viewable') {
        <div class="fill-parent cursor-pointer" (click)="conversationStore.viewMessagePhoto(message)">
          <button
            class="center-absolute"
            sbButton
            [variant]="message.is_me ? 'fill-semi-transparent-white' : 'fill-green'"
          >
            View
          </button>

          <div class="text-small position-absolute bottom-0 left-0 mf-2 display-flex align-items-center color-white">
            <sb-expire-graph
              class="mr-1"
              [theme]="'message-photo'"
              [value]="{ createdAt: message.timestamp, expiresAt: message.photo.expires_at }"
            />
            {{ (message.photo.expires_at | expiryTimer: ['Hour', 'Minute', 'Second'])! | parseMs: 'compact' }}
          </div>
        </div>
      }
      @case ('pending') {
        <div class="fill-parent cursor-pointer" (click)="onPhotoPendingClick()">
          <button
            class="center-absolute"
            sbButton
            [variant]="message.is_me ? 'fill-semi-transparent-white' : 'fill-green'"
          >
            View
          </button>

          <div
            class="text-small position-absolute bottom-0 left-0 mf-2 display-flex align-items-center color-white font-weight-500"
          >
            <sb-icon class="mr-1" [name]="'time'" [size]="'5'" />
            Pending...
          </div>
        </div>
      }
      @case ('locked') {
        <div class="fill-parent">
          <button
            class="center-absolute white-space-nowrap"
            sbButton
            [processing]="message.unlockInProgress"
            [variant]="'fill-gold'"
            (click)="conversationStore.attemptToUnlockMessagePhoto(message, conversation)"
          >
            Unlock Photo
          </button>
          <div class="position-absolute bottom-0 left-0 mf-4 font-weight-500">
            @let expiresIn = message.photo.expires_at | expiryTimer: [12 * Timespan.Hour];

            <div
              class="expires-in text-tiny font-weight-500 text-transform-uppercase letter-spacing-0.06 mb-1"
              [ngClass]="expiresInClass(expiresIn!)"
            >
              Expires in
            </div>
            <div class="text-small color-white opacity-60">
              {{ (message.photo.expires_at | expiryTimer)! | parseMs: '(hh)h : (mm)m : (ss)s' }}
            </div>
          </div>
        </div>
      }
    }
  </div>
}
